import { render, staticRenderFns } from "./AdsProviderLookup.vue?vue&type=template&id=96b04cb4&lang=pug"
import script from "./AdsProviderLookup.vue?vue&type=script&lang=js"
export * from "./AdsProviderLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports